
export default {
    name: "popup_resource",
    props: ["items", "type"],
    data(){
        return {
            selectedLang: "en",
            openedItem: null,

            langText: {
                en: {
                    title: "RESOURCES",
                    view: "View",
                    download: "Download",
                    back: "Back"
                },
                cn: {
                    title: "RESOURCES",
                    view: "查看",
                    download: "下载",
                    back: "返回"
                }
            },
        }
    },
    computed: {
        getTitle(){
            if(this.openedItem) return this.openedItem[`title_${ this.selectedLang }`];
            return this.langText[this.selectedLang].title;
        },
        getMyResourceUrl(){
            return "/static/pdf_viewer/web/viewer.html?file=./../.." + this.openedItem[`view_url_${ this.selectedLang }`];
        }
    },
    mounted(){
        if(this.items.length == 1) this.onClickViewItem(this.items[0]);
    },
    methods: {
        onClickViewItem(item){
            this.openedItem = item;
            this.onTriggerStampItem(item);
            this.onHandleTriggerAnalytics(`open@${ item.stamp } (${ this.selectedLang })@${ this.type }`); 
        },
        onClickDownloadItem(item){
            this.onTriggerStampItem(item);
            this.onHandleTriggerAnalytics(`download@${ item.stamp } (${ this.selectedLang })@${ this.type }`); 
        },
        onTriggerStampItem(item){
            if(item.stamp && item.room){
                this.$store.dispatch("stamp/onSubmitStamp", { title: item.stamp, room: this.roomItems[item.room] });
            }
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@${ this.type }`); 
        },
    },
    watch: {
        "selectedLang"(){
            this.onHandleTriggerAnalytics(`change_language@${ this.selectedLang }@${ this.type }`); 
        }
    }
}
